// src/Products.js (updated)
import React from "react";
import { Link } from "react-router-dom";

function Products() {
    // Define the product data (with icons for the list view)
    const products = [
        { id: 1, name: "Eco-Friendly Mug", price: 15.0, icon: "☕" },
        { id: 2, name: "Wireless Charger", price: 35.5, icon: "🔋" },
        {
            id: 3,
            name: "Noise-Cancelling Headphones",
            price: 199.99,
            icon: "🎧",
        },
    ];

    return (
        <div className="container mt-5">
            <h1 className="mb-4">Our Products</h1>
            <p className="lead">
                Click on any item to view details on its dedicated page:
            </p>

            {/* Bootstrap List Group for an iconic layout */}
            <ul
                className="list-group"
                style={{ maxWidth: "500px", margin: "auto" }}
            >
                {products.map((product) => (
                    // Use the dynamic Link syntax here
                    <li
                        key={product.id}
                        className="list-group-item d-flex justify-content-between align-items-center"
                    >
                        <Link
                            to={`/products/${product.id}`}
                            className="text-decoration-none fs-5"
                        >
                            <span className="me-3">{product.icon}</span>
                            {product.name}
                        </Link>
                        <span className="badge bg-primary rounded-pill">
                            ${product.price.toFixed(2)}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Products;
